module.exports = __webpack_public_path__ + "img/icon-16-ic-arrow-s.97ac4843.svg";